import type { fabric } from 'fabric';

export const RESIZE_ARTBOARD_EVENT = 'craftara:resize-artboard';

export function requestResizeArtboard(width: number, height: number): void {
  window.dispatchEvent(
    new CustomEvent(RESIZE_ARTBOARD_EVENT, {
      detail: { width, height },
    })
  );
}

/** Change artboard size without cropping objects (content stays put). */
export function resizeArtboard(
  canvas: fabric.Canvas,
  width: number,
  height: number
): { width: number; height: number } {
  const w = Math.max(32, Math.round(width));
  const h = Math.max(32, Math.round(height));
  canvas.setWidth(w);
  canvas.setHeight(h);
  canvas.calcOffset();
  canvas.requestRenderAll();
  return { width: w, height: h };
}
